const REG_IMAGE = /\.(jpg|png|gif)$/i;

export { REG_IMAGE as R };
//# sourceMappingURL=isImage-DdKfefTy.js.map
